export default __webpack_public_path__ + "media/color/bix-b64ecf8c.svg";